import React from 'react';
import Select from 'react-select'; 
import CustomValueContainer from '../../common/CustomValueContainer';
import { useTranslation } from "react-i18next";
import { SCHEME_TYPE_IDS_FOR_AGEING_DAYS_SELECTION, SCHEME_TYPE_IDS_FOR_DEALER_REMAINING_LIMIT, SCHEME_TYPE_IDS_FOR_INCENTIVE_TYPE_SELECTION, SCHEME_TYPE_IDS_FOR_THRESHOLD_GMV_SELECTION } from '../../../config/constant';
import InputField from '../../common/InputField';

const BasicDetails = (props) => {
    let { element,tempErrors } = props;
  
    const { product_type, scheme_duration,applicable_to, calculation_type } = props.incentive_config;
    const { t } = useTranslation("common"); 
    //const [refresh, setRefresh] = useState(1);
    // const [productTypeOption, setProductTypeOption] = useState({});
    // const [schemeDurationOption, setSchemeDurationOption] = useState({});
    // const [applicabletoOption, setApplicabletoOption] = useState({});

    // useEffect(() => {
    //     let ProductTypeOption= element.product_type ? { value: element.product_type, label: element.product_type } : {};

    //     let  SchemeDurationOption=element.scheme_duration ? { value: element.scheme_duration, label: element.scheme_duration } :{};

    //     let ApplicabletoOption= element.applicable_to ? { value: element.applicable_to, label: element.applicable_to } : {};
        
    //     // setProductTypeOption(ProductTypeOption);
    //     // setSchemeDurationOption(SchemeDurationOption);
    //     // setApplicabletoOption(ApplicabletoOption);
       
    // },[props])

    const handleChangeProductType = (ProductTypeOption) => {
        // setProductTypeOption(ProductTypeOption);
        props.onChange("product_type", ProductTypeOption, '', props.element)
    };

    const handleChangeSchemeDuration = (SchemeDurationOption) => {
        // setSchemeDurationOption(SchemeDurationOption);
        props.onChange("scheme_duration", SchemeDurationOption, '',props.element)
        if(props.element.form_config.SCHEME_DURATION ){
            props.onChange("scheme_duration_value", {...SchemeDurationOption, value: SchemeDurationOption['label']}, '',props.element)
        }
    };

    const handleChangeApplicableto = (applicabletoOption) => {
        // setApplicabletoOption(applicabletoOption);
        props.onChange("applicable_to", applicabletoOption.label, '', props.element)
    };

    const handleChangeCalculationType = (option) => {
        props.onChange("calculation_type", option.label, '', props.element);
    }

    const handleChangeAgeingDays = (e) => {
        if ((e.target.value >= 1 && e.target.value <= 30) || !e.target.value) {
            props.onChange("ageing_days", e.target.value, '', props.element);
        }
    }

    const handleChangeThresholdGmv = (e) => {
        props.onChange("threshold_gmv", e.target.value, "", props.element);
    };

    const handleChangeDealerRemainingLimit = (e) => {
        props.onChange("dealer_remaining_limit", e.target.value, "", props.element);
    };
        
    return (
        <React.Fragment>
            <div className='basic-filter-outer'>
                <div className="basic-detail-filter">
                    <fieldset className="single-select">
                        <div className="material">
                            <Select
                            components={{ ValueContainer: CustomValueContainer }}
                            value={element.product_type ? product_type.filter(ob=>ob.value===element.product_type):''}
                            onChange={handleChangeProductType}
                            options={product_type.filter(ob=>ob.incentive_type===1)}
                            isDisabled={element.is_expired}
                            placeholder={t('FORM.PRODUCT_TYPE') + '*'}
                            className="react-select"
                            classNamePrefix="react-select"
                            isSearchable={false}
                            />
                        </div>
                        { tempErrors && tempErrors.product_type ? <span className="error show">{tempErrors.product_type}</span> : <span>&nbsp;</span>}
                    </fieldset>

                    <fieldset className="single-select">
                        <div className="material">
                            {
                                !element.is_expired 
                                ?
                                <Select components={{ ValueContainer: CustomValueContainer }}
                                    value={element.scheme_duration ? scheme_duration.filter(({ value }) => Number(value) === Number(element.scheme_duration)) : null}
                                    onChange={handleChangeSchemeDuration}
                                    options={scheme_duration}
                                    isDisabled={element.is_expired || false}
                                    placeholder={t('FORM.SCHEME_DURATION') + '*'}
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    isSearchable={false}
                                />
                                :
                                
                                <Select components={{ ValueContainer: CustomValueContainer }}
                                value={[{value: '', label: element.scheme_duration_value}]}
                                onChange={handleChangeSchemeDuration}
                                options={scheme_duration}
                                isDisabled={element.is_expired}
                                placeholder={t('FORM.SCHEME_DURATION')+ '*'}
                                className="react-select"
                                classNamePrefix="react-select"
                                isSearchable={false}
                            />

                            }
                            
                        </div>
                        {
                            (tempErrors && tempErrors.scheme_duration) ? <span className="error show">{tempErrors.scheme_duration}</span> : <span>&nbsp;</span>
                        }
                    </fieldset>

                    
                        <fieldset className="single-select">
                            <div className="material">
                                <Select components={{ ValueContainer: CustomValueContainer }}
                                value={element.applicable_to?applicable_to.filter((el) =>el.label.toLowerCase() === element.applicable_to.toLowerCase()):''}
                                onChange={handleChangeApplicableto}
                                options={applicable_to}
                                isDisabled={element.is_expired}
                                placeholder={t('FORM.APPLICABLE_TO') + '*'}
                                className="react-select"
                                classNamePrefix="react-select"
                                isSearchable={false}
                                />
                            </div>
                            {
                            (tempErrors && tempErrors.applicable_to) ? <span className="error show">{tempErrors.applicable_to}</span> : <span>&nbsp;</span>
                            }
                        </fieldset>
                    
                        {SCHEME_TYPE_IDS_FOR_INCENTIVE_TYPE_SELECTION.includes(
                            +element.scheme_type_id
                        ) ? (
                            <fieldset className="single-select">
                                <div className="material">
                                    <Select
                                        components={{ ValueContainer: CustomValueContainer }}
                                        value={
                                            element.calculation_type
                                            ? calculation_type.filter(
                                                (cTypeOption) =>
                                                    cTypeOption.label.toLowerCase() ===
                                                    element.calculation_type.toLowerCase()
                                                )
                                            : ""
                                        }
                                        onChange={handleChangeCalculationType}
                                        options={calculation_type}
                                        isDisabled={element.is_expired}
                                        placeholder={t("FORM.CALCULATION_TYPE") + "*"}
                                        className="react-select"
                                        classNamePrefix="react-select"
                                        isSearchable={false}
                                    />
                                </div>
                            {tempErrors && tempErrors.calculation_type ? (
                                <span className="error show">{tempErrors.calculation_type}</span>
                            ) : (
                                <span>&nbsp;</span>
                            )}
                            </fieldset>
                        ) : null}
                    
                        {SCHEME_TYPE_IDS_FOR_AGEING_DAYS_SELECTION.includes(
                            +element.scheme_type_id
                        ) ? (
                            <fieldset className="">
                                <div className="material">
                                    <InputField
                                        inputProps={{
                                            id: "ageing_days",
                                            type: "number",
                                            name: "ageing_days",
                                            placeholder: " ",
                                            value: element.ageing_days || "",
                                            className: "form-input",
                                            disabled: element.is_expired,
                                            label: "test"
                                        }}
                                        onChange={handleChangeAgeingDays}
                                    />
                                    <label data-label={`${t('FORM.AGEING_DAYS')}*`} className="form-label"></label>
                                </div>
                            {tempErrors && tempErrors.ageing_days ? (
                                <span className="error show">{tempErrors.ageing_days}</span>
                            ) : (
                                <span>&nbsp;</span>
                            )}
                            </fieldset>
                        ) : null}
                    
                        {SCHEME_TYPE_IDS_FOR_THRESHOLD_GMV_SELECTION.includes(
                            +element.scheme_type_id
                        ) ? (
                            <fieldset className="">
                                <div className="material">
                                    <InputField
                                        inputProps={{
                                            id: "threshold_gmv",
                                            type: "number",
                                            name: "threshold_gmv",
                                            placeholder: " ",
                                            value: element.threshold_gmv || "",
                                            className: "form-input",
                                            disabled: element.is_expired,
                                            label: "test"
                                        }}
                                        onChange={handleChangeThresholdGmv}
                                    />
                                    <label data-label={`${t('FORM.THRESHOLD_GMV')}*`} className="form-label"></label>
                                </div>
                            {tempErrors && tempErrors.threshold_gmv ? (
                                <span className="error show">{tempErrors.threshold_gmv}</span>
                            ) : (
                                <span>&nbsp;</span>
                            )}
                            </fieldset>
                        ) : null}
                    
                        {SCHEME_TYPE_IDS_FOR_DEALER_REMAINING_LIMIT.includes(
                            +element.scheme_type_id
                        ) ? (
                            <fieldset className="">
                                <div className="material">
                                    <InputField
                                        inputProps={{
                                            id: "dealer_remaining_limit",
                                            type: "number",
                                            name: "dealer_remaining_limit",
                                            placeholder: " ",
                                            value: element.dealer_remaining_limit || "",
                                            className: "form-input",
                                            disabled: element.is_expired,
                                            label: "test"
                                        }}
                                        onChange={handleChangeDealerRemainingLimit}
                                    />
                                    <label data-label={`${t('FORM.DEALER_REMAINING_LIMIT')}*`} className="form-label"></label>
                                </div>
                            {tempErrors && tempErrors.dealer_remaining_limit ? (
                                <span className="error show">{tempErrors.dealer_remaining_limit}</span>
                            ) : (
                                <span>&nbsp;</span>
                            )}
                            </fieldset>
                        ) : null}

                </div>
            </div>
        </React.Fragment>
    );       
          
            

}


export default BasicDetails;